module.exports = __webpack_public_path__ + "static/media/add_queue.06dad9f4.svg";